import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceInput, AutocompleteInput } from 'react-admin';

const ArtistExperienceEdit = (props) => (
  <EditGuesser {...props}>
    <ReferenceInput
      label="SubCategory"
      source="subCategory"
      reference="portfolio_sub_categories"
      perPage={10000}
    >
      <AutocompleteInput
        optionText="title"
        shouldRenderSuggestions={(value) => value.trim().length >= 1}
      />
    </ReferenceInput>

    <InputGuesser source="status" />
  </EditGuesser>
  );

export default ArtistExperienceEdit;